module.exports = {"event_expiry":"HURRY! EVENT EXPIRES  "}